/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useRef, useState } from "react";

//import redux
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addFieldForceAccNewLabel,
  removeFieldForceAccNewLabel,
  resetToggleFfa,
  setToggleFfa,
} from "../../../redux/features/accounts/fieldForceAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";

//import components
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons/index.js";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo/index.jsx";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import ListContainer from "../../../components/_utils/CommonListView/ListContainer/index.jsx";
import ListTextWithIcon from "../../../components/_utils/CommonListView/ListSubComponent/ListTextWithIcon/index.jsx";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import CardContainer from "../../../components/_utils/CommonViewAllCard/CardContainer/index.jsx";
import TextWithIcon from "../../../components/_utils/CommonViewAllCard/CardSubComponent/TextWithIcon/index.jsx";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber/index.js";
import IfscCodeMapper from "../../../components/_utils/IfscLogoMapper/index.js";
import PaginationComponent from "../../../components/_utils/PaginationComponent/index.jsx";
import TickerAnimation from "../../../components/_utils/TickerAnimation/index.jsx";
import Loader from "../../../components/Loader/Index.jsx";
import { getAllFieldForceAccount } from "../../../redux/features/accounts/fieldForceAccount/index.js";
import { getAllCategories } from "../../../redux/features/sharedResources/sharedResources.js";
import accountNameStandardised from "../../../utils/accountNamestandardised.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider.js";
import { standardAccountNumberFormat } from "../../../utils/standardAccountNumberFormat.js";
import useCustomSearchParams from "../../../utils/useCustomSearchParams";
import useMultiSelect from "../../../utils/useMultiSelect.js";
import useRestrictedAction from "../../../hooks/useRestrictedAction.js";
import UseHandleScroll from "../../../hooks/useHandleScroll.js";
import SmallPopup from "../../../components/_utils/CommonSmallPopup/index.jsx";

const parseDateRangeFromUrl = (dateStr) => {
  if (!dateStr) return { start: "", end: "" };
  const parts = dateStr.split(",");
  const start = parts[0] ? Number(parts[0]) : "";
  const end = parts[1] ? Number(parts[1]) : "";
  return { start: isNaN(start) ? "" : start, end: isNaN(end) ? "" : end };
};

const FieldForceAccountViewAll = ({
  id,
  panNum,
  fieldForcePan,
  type,
  bankAccNumber,
  fieldForceAccountNo,
  flow,
  setOpenBeneAssociate,
  ifscCode,
  fieldForceIFSC,
  setModalOpen,
  setTxnPayLoad,
  onAccountSelect,
  popupType,
  accActiveInactiveState,
  activeInactivePan,
  activeInactiveFlow,
  activeInactiveIfsc,
  activeInactiveBank,
  setFlowSelectedId,
  setIsalertPopup,
  classifiedFlow = false,
  handleClosePopup,
  activeType,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownOptionsList = PaginationConfiguration.paginationOptions;
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { toggleFfa } = useSelector((state) => state.fieldForceAccount);
  const { services } = useSelector((state) => state.refreshToken);
  const dispatch = useDispatch();
  const lastScrollTop = useRef(GlobalConfiguration.lengthCheckZero);
  const [direction, setDirection] = useState("");

  const { handleScroll } = UseHandleScroll(setDirection, lastScrollTop);

  const {
    handleChange,
    handleSelectAll: handleMultiSelectAll,
    handleSingleSelect,
  } = useMultiSelect();

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "rejected":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--awaiting)";
    }
  };

  // useref
  const dropdownRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const approvalStatusSyncedToUrlRef = useRef(false);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const scrollContainerRef = useRef(null);
  const lastElementRef = useRef();

  //usestate
  const [limit24hr] = useState("");
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptionsList[0],
  });
  const dateFromUrl = parseDateRangeFromUrl(searchParam.get("date"));
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [closeCard, setCloseCard] = useState(false);
  const [currentAccountId, setCurrentAccountId] = useState("");
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const isEmbeddedPopup = classifiedFlow || popupType === "associated";
  const [LabelSearchText, setLabelSearchText] = useState(
    type === "fieldForceAccount" || type === "activeInactive"
      ? []
      : searchParam.get("label")?.split(",").filter(Boolean) || [],
  );

  const [showSearchBar, setShowSearchBar] = useState(false);

  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    type === "fieldForceAccount" || type === "activeInactive"
      ? 1
      : Number(searchParam.get("pageno")) || GlobalConfiguration.lengthCheckOne,
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(
    type === "fieldForceAccount" || type === "activeInactive"
      ? ""
      : location?.state?.approvalStatus === "approved"
        ? "approved"
        : location?.state?.approvalStatus === "pending"
          ? "pending"
          : searchParam.get("status") || "",
  );

  const [currentCategory, setCurrentCategory] = useState(
    type === "fieldForceAccount" || type === "activeInactive"
      ? ""
      : searchParam.get("category") || "",
  );
  const [displayCategory, setDisplayCategory] = useState(
    searchParam.get("dispCat") || "",
  );
  const [searchUserText, setSearchUserText] = useState(
    type === "fieldForceAccount" || type === "activeInactive"
      ? ""
      : searchParam.get("search") || "",
  );

  const [startDateFilter, setStartDateFilter] = useState(
    type === "fieldForceAccount" || type === "activeInactive"
      ? ""
      : dateFromUrl.start,
  );
  const [endDateFilter, setEndDateFilter] = useState(
    type === "fieldForceAccount" || type === "activeInactive"
      ? ""
      : dateFromUrl.end,
  );
  const [accountNumber, setAccountNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveBank
      : type === "fieldForceAccount" ||
          type === "activeInactive" ||
          popupType === "associated"
        ? ""
        : type === "confirm_create_account"
          ? bankAccNumber
          : searchParam.get("accountNo") || "",
  );

  const [isIfsc, setIsIfsc] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Bank" || activeInactiveFlow === "Existing")
      ? activeInactiveIfsc
      : type === "fieldForceAccount" ||
          type === "activeInactive" ||
          popupType === "associated"
        ? ""
        : type === "confirm_create_account"
          ? ifscCode
          : searchParam.get("ifsc") || "",
  );
  const [panNumber, setPanNumber] = useState(
    type === "activeInactive" &&
      (activeInactiveFlow === "Pan" || activeInactiveFlow === "Existing")
      ? activeInactivePan
      : type === "fieldForceAccount" ||
          type === "activeInactive" ||
          popupType === "associated"
        ? ""
        : type === "confirm_create_account"
          ? panNum
          : searchParam.get("pan") || "",
  );

  const [isFilterApplied, setIsFilterApplied] = useState(false);

  const [selectedValue, setSelectedValue] = useState(
    type === "fieldForceAccount" || type === "activeInactive"
      ? PaginationConfiguration.paginationSmall
      : searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const [mainData, setMainData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const [pageSize, setPageSize] = useState(
    type === "fieldForceAccount" || type === "activeInactive"
      ? PaginationConfiguration.paginationSmall
      : searchParam.get("pagesize") || PaginationConfiguration.paginationSmall,
  );

  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [labels, setLabels] = useState([]);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);

  const isUppercaseLabel = (label) => {
    if (typeof label !== "string") return false;
    const trimmed = label.trim();
    if (!trimmed) return false;
    return /[A-Z]/.test(trimmed);
  };

  const filterUppercaseLabels = (labelList) =>
    (Array.isArray(labelList) ? labelList : []).filter(
      (label) => !isUppercaseLabel(label),
    );

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [animateViewAll, setAnimateViewAll] = useState(false); // State defined for managing the initial animation of grid view
  const [inputData, setInputData] = useState([]);

  const handleSubmit = (key, value) => {
    if (
      type !== "fieldForceAccount" &&
      type !== "activeInactive" &&
      type !== "confirm_create_account"
    ) {
      handleSearchParams(key, value);
    }
  };

  const resetToFirstPage = () => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    handleSubmit("pageno", GlobalConfiguration.lengthCheckOne);
  };

  const handleSelectAll = () => {
    handleMultiSelectAll(
      LabelAccounts,
      setLabelAccounts,
      selectedValue,
      selectableAccounts,
    );
  };

  const handleLabelAccountSelect = (account) => {
    handleSingleSelect(LabelAccounts, setLabelAccounts, selectedValue, {
      ...account,
      id: account?.id,
    });
  };

  const handleClose = () => {
    setIsLabelPopupOpen(false);

    if (labelActionDispatchedRef.current) {
      fetchData();
      labelActionDispatchedRef.current = false;
      setLabelAccounts([]);
      setisLabelClicked(false);
      setShowSearchBar(false);
      setSearchUserText("");
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
  };

  const handleDataPopup = (data) => {
    onAccountSelect(
      data?.bank_name,
      data?.bank_acc_no,
      data?.ifsc_code,
      data?.id,
      data?.category,
      data?.pan_no,
      data?.labels,
    );
    setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountIFSC: data.ifsc_code,
      bankAccountName: data.bank_account_holder_full_name,
      bankAccountNo: data.bank_acc_no,
      bankLogo: data.bank_name,
      beneAccountId: data.id,
      pan: data.pan_no,
      labels: data.labels,
      // settleType: data.settle_type,
    }));
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDateChange = (date) => {
    resetToFirstPage();
    if (date) {
      const [start, end] = date;
      const startTs = convertDate(start);
      const endTs = convertDate(end);
      setStartDateFilter(startTs);
      setEndDateFilter(endTs);
      if (type !== "fieldForceAccount" && type !== "activeInactive") {
        handleSearchParams("date", `${startTs},${endTs}`);
      }
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
      if (type !== "fieldForceAccount" && type !== "activeInactive") {
        handleSearchParams("date", "");
      }
    }
  };

  const handleToggle = (newToggleValue) => {
    if (loading) {
      setAnimateViewAll(false);
    } else {
      setAnimateViewAll(true);
    }

    if (toggleFfa !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({
        top: GlobalConfiguration?.lengthCheckZero,
        behavior: "smooth",
      });
    }
    dispatch(setToggleFfa(newToggleValue));
  };

  const handleSelect = (value) => {
    if (
      isLabelClicked &&
      value === PaginationConfiguration.paginationSmall &&
      LabelAccounts?.length > PaginationConfiguration.paginationSmall
    ) {
      handleChange(LabelAccounts, setLabelAccounts, value, selectableAccounts);
    }
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    if (type !== "fieldForceAccount" && type !== "activeInactive") {
      handleSearchParams("pagesize", value);
      handleSearchParams("pageno", GlobalConfiguration.lengthCheckOne);
    }
    toggleDropdown();
  };

  const filteredData = accumulatedData;
  const selectableAccounts = accumulatedData?.map((item) => ({
    ...item,
    id: item?.id,
  }));

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const handlePagination = (page) => {
    setDirection("");
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop =
        GlobalConfiguration?.lengthCheckZero;
    }
    setCurrentPage(page);
    if (type !== "fieldForceAccount" && type !== "activeInactive") {
      handleSearchParams("pageno", page);
    }
  };

  const handleClearFilters = () => {
    setAnimateViewAll(false);
    const defaultPage = GlobalConfiguration?.lengthCheckOne;
    const defaultSize = dropdownOptionsList[0];
    setCurrentCategory("");
    setDisplayCategory("");
    setStartDateFilter("");
    setEndDateFilter("");
    setAccountNumber("");
    setShowSearchBar(false);
    setSearchUserText("");
    setIsIfsc("");
    setLabelSearchText([]);
    setisLabelClicked(false);
    setCurrentStatus("");
    setCurrentPage(defaultPage);
    setSearchUserTextDebounce("");
    setPanNumber("");

    if (type !== "fieldForceAccount" && type !== "activeInactive") {
      navigate(
        {
          pathname: location.pathname,
          search: `?pageno=${defaultPage}&pagesize=${defaultSize}`,
        },
        { replace: true },
      );
    }
    if (type === "activeInactive" && activeInactiveFlow === "Pan") {
      setPanNumber(activeInactivePan);
    } else if (type === "activeInactive" && activeInactiveFlow === "Bank") {
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    } else if (activeInactiveFlow === "Existing") {
      setPanNumber(activeInactivePan);
      setAccountNumber(activeInactiveBank);
      setIsIfsc(activeInactiveIfsc);
    } else if (type === "confirm_create_account") {
      if (activeType === "Pan") {
        setPanNumber(panNum);
      } else {
        setAccountNumber(bankAccNumber);
        setIsIfsc(ifscCode);
      }
    }
  };

  useEffect(() => {
    if (type === "fieldForceAccount" || approvalStatusSyncedToUrlRef.current) {
      return;
    }
    const statusFromState = location?.state?.approvalStatus;
    if (statusFromState === "approved" || statusFromState === "pending") {
      handleSearchParams("status", statusFromState);
      approvalStatusSyncedToUrlRef.current = true;
    }
  }, [location?.state?.approvalStatus, type, handleSearchParams]);

  const fetchData2 = async () => {
    let response;
    let data = [];
    setLoadingData(true);
    setAnimateViewAll(false);

    switch (active) {
      case "Category":
        response = await dispatch(
          getAllCategories({ search_string: searchUserTextDebounce }),
        );
        data = response?.payload?.categories?.map((itm) => {
          return {
            id: itm.id,
            Category: itm.name,
            Description: itm?.description || "Not given",
          };
        });
        setInputData(data);
        setLoadingData(false);
        break;
      case "Labels":
        data = labels
          ?.filter((itm) => {
            return itm.includes(searchUserTextDebounce);
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active]);

  async function fetchData() {
    setLoading(true);
    setAnimateViewAll(false);
    try {
      if (currentPage === GlobalConfiguration.lengthCheckOne) {
        setLoading(true);
      }

      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
        ...(type === "activeInactive" && {
          associate:
            type === "activeInactive" && accActiveInactiveState === "active"
              ? ["pending", "approved"]
              : type === "activeInactive" &&
                  accActiveInactiveState === "inactive"
                ? ["blocked", "archived", "rejected"]
                : undefined,
        }),
      };

      const addParamsBasedOnSelection = () => {
        if (currentStatus !== "all") {
          queryParams.approval_status =
            currentStatus === "require approval" ? "pending" : currentStatus;
        }
        if (currentCategory !== "") {
          queryParams.category_ids = Array.isArray(currentCategory)
            ? currentCategory
            : [currentCategory];
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          !!startDateFilter &&
          !!endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date = startDateFilter + 86400;
          queryParams.end_date = endDateFilter + 86400;
        }

        if (accountNumber !== "" || fieldForceAccountNo) {
          queryParams.bank_account_no = fieldForceAccountNo
            ? fieldForceAccountNo
            : accountNumber;
        }

        // if (limit24hr) {
        //   queryParams.field_force_custom_limit = limit24hr;
        // }

        if (limit24hr !== "" && !isNaN(Number(limit24hr))) {
          queryParams.field_force_custom_limit = Number(limit24hr);
        }

        if (isIfsc !== "" || fieldForceIFSC) {
          queryParams.ifsc = fieldForceIFSC
            ? fieldForceIFSC.toUpperCase()
            : isIfsc.toUpperCase();
        }

        if (panNumber !== "" || fieldForcePan) {
          queryParams.pan = fieldForcePan
            ? fieldForcePan.toUpperCase()
            : panNumber.toUpperCase();
        }

        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (!!LabelSearchText?.length) {
          queryParams.labels = LabelSearchText;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(getAllFieldForceAccount(queryParams));
      const newData = response?.payload?.field_force_accounts || [];
      setMainData(response?.payload);

      setAccumulatedData(newData);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
    setTimeout(() => {}, IntervalConfiguration.intervalExtraLarge);
  }

  const onMount = () => {};

  useEffect(() => {
    dispatch(enableSwitcher());

    onMount();
    return () => {
      dispatch(setToggleFfa(false));
      dispatch(disableSwitcher());
    };
  }, [markerData]);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
    }
  }, []);

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, recordIdsFromPopup) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);

    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(LabelAccounts)
            ?.map((item) => item?.id || item)
            ?.filter(Boolean);

    const res = await dispatch(
      addFieldForceAccNewLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );

    if (addFieldForceAccNewLabel?.fulfilled?.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Labels assigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalMedium);
      await fetchData();

      setLabelAccounts((prev) =>
        prev.map((account) => ({
          ...account,
          labels: [...new Set([...(account.labels || []), ...labelsToAssign])],
        })),
      );
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (addFieldForceAccNewLabel?.rejected?.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalMedium);
    }

    setLoading(false);
    if (addFieldForceAccNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (
    labelsToUnassign,
    recordIdsFromPopup,
  ) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    // Mirror Internal exactly — use recordIdsFromPopup if provided
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(LabelAccounts)
            ?.map((item) => item?.id || item)
            ?.filter(Boolean);

    const res = await dispatch(
      removeFieldForceAccNewLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );

    if (removeFieldForceAccNewLabel?.fulfilled?.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Labels unassigned successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalMedium);
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }

    if (removeFieldForceAccNewLabel?.rejected?.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalMedium);
    }

    setLoading(false);
    if (removeFieldForceAccNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("fFAccAvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(filterUppercaseLabels(parsedLabels));
  }, [
    markerData,
    currentPage,
    currentStatus,
    currentCategory,
    searchUserText,
    startDateFilter,
    endDateFilter,
    accountNumber,
    limit24hr,
    pageSize,
    LabelSearchText,
    fieldForceAccountNo,
    fieldForceIFSC,
    fieldForcePan,
    isIfsc,
    panNumber,
    accActiveInactiveState,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    isIfsc,
    currentStatus,
    limit24hr,
  ]);
  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        (currentStatus !== "all" && !!currentStatus),
    );
  };

  useEffect(() => {
    if (type === "fieldForceAccount") {
      setCurrentPage(GlobalConfiguration?.lengthCheckOne);
    }
    if (type === "activeInactive") {
      dispatch(resetToggleFfa());
    }
  }, []);

  useEffect(() => {
    if (type === "confirm_create_account") {
      setPanNumber(panNum || "");
      setIsIfsc(ifscCode || "");
      setAccountNumber(bankAccNumber || "");
    }
  }, [panNum, ifscCode, bankAccNumber, type]);

  const handleEmbeddedPopupAccountNavigate = (accountId) => {
    setCurrentAccountId(accountId);
    setCloseCard(true);
  };

  const handleConfirmLeaveAccount = () => {
    setCloseCard(false);
    handleClosePopup?.();
    if (popupType === "associated") {
      setOpenBeneAssociate?.(false);
    }
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${currentAccountId}`,
      {
        replace: true,
        state: {
          isViewAll: location.pathname.includes("view_all"),
        },
      },
    );
    setCurrentAccountId("");
  };

  return (
    <>
      <div
        className={`bg-primary-bg ${type === "fieldForceAccount" || type === "activeInactive" || type === "confirm_create_account" ? "h-full" : "h-screen"}  flex flex-col  relative `}
        style={{
          position:
            type === "fieldForceAccount" ||
            type === "activeInactive" ||
            type === "confirm_create_account"
              ? ""
              : "relative",
          overflow: "hidden",
          width:
            type === "fieldForceAccount" ||
            type === "activeInactive" ||
            type === "confirm_create_account"
              ? ""
              : "var(--full-width)",
        }}
      >
        <div
          className={` ${type === "fieldForceAccount" ? " absolute" : "absolute"} bg-primary-nav ${showInnerSearchBar ? "z-z-index-header" : "z-z-index-dropdown"} shadow-box-shadow-top 
               bottom-bottom-base w-full rounded-none
          `}
        >
          {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
            filteredData?.length > GlobalConfiguration.lengthCheckZero && (
              <>
                <div
                  className={`${loading && "hidden"} ${
                    showInnerSearchBar && "pointer-events-none h-full"
                  }`}
                >
                  {showInnerSearchBar && (
                    <div className="bg-PopUp-BackDrop opacity-light-opacity absolute w-full h-full z-z-index-overlay" />
                  )}
                  <PaginationComponent
                    dropdownOptions={dropdownOptionsList}
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    handlePagination={handlePagination}
                    currentPage={currentPage}
                    setIsOpen={setIsOpen}
                  />
                </div>
              </>
            )}
        </div>

        {closeCard && (
          <div className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle={"Confirm leaving this page?"}
              headerFontWeight="semibold"
              headerFontColor="emphasis"
              textSize="font-lg"
              subtext={"Leaving this page will exit from the current flow."}
              btnOneText="Stay"
              btnOneHandleFunction={() => setCloseCard(false)}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Leave"
              btnTwoHandleFunction={handleConfirmLeaveAccount}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoIsLoaderNeeded={true}
              btnTwoHoverOption="black"
            />
          </div>
        )}
        {isLabelPopupOpen && (
          <div
            onClick={() => {
              setIsLabelPopupOpen(false);
            }}
            className="fixed top-top-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
          >
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={LabelAccounts}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              // handleAssignLabels={() => {}}
              // handleUnassignLabels={() => {}}
            />
          </div>
        )}
        <div
          className={`Label_top_line_of_div w-full hidden `}
          style={{
            zIndex: "var(--z-index-overlay)",
          }}
        >
          <div>
            <p className="w-width-full font-open-sans text-font-xs text-text-primary">
              Only active (pending & approved) accounts are enabled for
              selection.
            </p>
          </div>
        </div>

        <div
          className={` relative ${type === "fieldForceAccount" || type === "activeInactive" || type === "confirm_create_account" ? "hidden" : "block"} z-z-index-overlay bg-primary-nav `}
        >
          <div>
            <div
              //
              className={`  hidden Qmd:block h-navbar-breadcrumb-height w-full ${direction === "down" ? "bg-primary-bg" : "bg-primary-nav"}  bg-primary-nav
                 
                `}
            ></div>
          </div>
        </div>

        <div
          className={`bene_div_container Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act w-full relative `}
        >
          <TopNavComponent
            direction={direction}
            topNavCtaBtn1Needed={false}
            topNavCtaBtn1Props={
              isLabelClicked
                ? {
                    btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                    btnType: "button",
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      const textContent = e.target.textContent.trim();
                      if (textContent === "Clear") {
                        setLabelAccounts([]);
                      }
                      if (textContent === "Cancel") {
                        setisLabelClicked(false);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: showSearchBar,
                    hoverOption: "white",
                  }
                : undefined
            }
            topNavCtaBtn2Needed={false}
            handleBack={
              type === "fieldForceAccount" ||
              type === "activeInactive" ||
              type === "confirm_create_account"
                ? undefined
                : () => {
                    navigate(GlobalConfiguration?.navigate_back);
                  }
            }
            topNavCtaBtn2Props={
              isLabelClicked
                ? {
                    btnText: "Assign labels",
                    btnType: "button",
                    enabledBgColor: LabelAccounts?.length
                      ? "var(--text-primary)"
                      : "var(--text-disabled)",
                    handleFunction: (e) => {
                      e.stopPropagation();
                      if (LabelAccounts?.length) {
                        setIsLabelPopupOpen(true);
                      }
                      if (
                        type === "activeInactive" ||
                        type === "confirm_create_account"
                      ) {
                        actionRestricted();
                      }
                    },
                    enabledTextColor: LabelAccounts?.length
                      ? "var(--primary-bg)"
                      : "Var(--text-primary)",
                    isDisabled:
                      isLabelClicked && LabelAccounts?.length ? false : true,
                    hoverOption:
                      isLabelClicked && LabelAccounts?.length
                        ? " white"
                        : "black",
                    inActiveVariantNeeded: true,
                  }
                : undefined
            }
            BottomSubText={
              isLabelClicked
                ? "Select accounts to apply labels. These labels will be used to generate statistics for the associated accounts."
                : undefined
            }
            BottomSubTextVaraint="primary"
            isSelectionView={isLabelClicked && true}
            isToggleNeeded={true}
            toggleProps={
              !isLabelClicked
                ? {
                    state: toggleFfa,
                    title: toggleFfa ? "Grid View" : "List View",
                    isDisabled: showSearchBar,
                    handleClick: () => handleToggle(!toggleFfa),
                  }
                : undefined
            }
            selectionText={`Accounts selected - ${LabelAccounts?.length || GlobalConfiguration.lengthCheckZero}`}
            selectionBtnProps={
              isLabelClicked
                ? {
                    btnText: `Select up to ${Number(selectedValue)}`,
                    btnType: "button",
                    enabledBgColor:
                      LabelAccounts?.length === Number(selectedValue)
                        ? "var(--positive-bg)"
                        : "var(--primary-nav-act)",
                    handleFunction: () => {
                      if (selectableAccounts?.length) {
                        handleSelectAll();
                      }
                    },
                    inActiveVariantNeeded: true,
                    enabledTextColor: "var(--text-primary)",
                    isDisabled:
                      loading ||
                      selectableAccounts?.length ===
                        GlobalConfiguration.lengthCheckZero,
                    hoverOption:
                      LabelAccounts?.length === Number(selectedValue)
                        ? "black"
                        : "white",
                    icon:
                      !loading &&
                      LabelAccounts?.length === Number(selectedValue)
                        ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                        : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                  }
                : undefined
            }
            assignLabelNeeded={true}
            assignTagNeeded={true}
            assignLabelProps={
              !isLabelClicked
                ? {
                    handleFunction: () => {
                      if (
                        loading ||
                        accumulatedData?.length ===
                          GlobalConfiguration.lengthCheckZero
                      ) {
                        return;
                      }
                      if (
                        flow === "create" ||
                        type === "fieldForceAccount" ||
                        type === "activeInactive" ||
                        type === "confirm_create_account"
                      ) {
                        actionRestricted();
                        return;
                      }
                      if (
                        services?.includes("ALabel") &&
                        services?.includes("RLabel")
                      ) {
                        if (showSearchBar) {
                          return;
                        }
                        setisLabelClicked((prev) => {
                          if (prev) {
                            setLabelAccounts([]);
                          }
                          return !prev;
                        });
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "ALabel,RLabel",
                          },
                        });
                      }
                    },

                    isDisabled:
                      type === "activeInactive" ||
                      type === "fieldForceAccount" ||
                      type === "confirm_create_account" ||
                      loading ||
                      accumulatedData?.length ===
                        GlobalConfiguration.lengthCheckZero
                        ? true
                        : false,
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,

                    hoverOption: "white",
                    buttonRef: null,
                    title:
                      "Labels will be used to generate statistics for the associated accounts",
                  }
                : undefined
            }
            filteredSearchProps={{
              setShowInnerSearchBar: setShowInnerSearchBar,
              showSearchBar: showSearchBar,
              isSearchDisabled: loading,
              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search field force account",
              filterPlaceholder:
                "name / contact number / email ID / account ID",
              filterItems: [
                {
                  name: "Search",
                  isMulti: false,
                  value: searchUserText,
                  setValue: (val) => {
                    resetToFirstPage();
                    setSearchUserText(val);
                    handleSubmit("search", val);
                  },
                  isDropdown: false,
                  isDisabled: loading,
                },
                {
                  name: "Account number",
                  short_name: "FF A/c",
                  isMulti: false,
                  value:
                    type === "confirm_create_account" && bankAccNumber
                      ? bankAccNumber
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Bank" ||
                            activeInactiveFlow === "Existing")
                        ? activeInactiveBank
                        : popupType === "associated"
                          ? fieldForceAccountNo
                          : fieldForceAccountNo !== "" &&
                              type === "fieldForceAccount" &&
                              flow !== "create"
                            ? fieldForceAccountNo
                            : accountNumber,
                  setValue: (val) => {
                    resetToFirstPage();
                    setAccountNumber(val);
                    handleSubmit("accountNo", val);
                  },
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : (fieldForceAccountNo !== "" &&
                            type === "fieldForceAccount") ||
                          (type === "confirm_create_account" &&
                            ifscCode &&
                            bankAccNumber)
                        ? true
                        : false,
                  valueType: "string",
                },
                {
                  name: "IFSC",
                  short_name: "IFSC",
                  isMulti: false,
                  value:
                    type === "confirm_create_account" && ifscCode
                      ? ifscCode
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Bank" ||
                            activeInactiveFlow === "Existing")
                        ? activeInactiveIfsc
                        : popupType === "associated"
                          ? fieldForceIFSC
                          : fieldForceIFSC !== "" &&
                              type === "fieldForceAccount" &&
                              flow !== "create"
                            ? fieldForceIFSC
                            : isIfsc.toUpperCase(),
                  setValue: (val) => {
                    resetToFirstPage();
                    setIsIfsc(val);
                    handleSubmit("ifsc", val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : (fieldForceIFSC !== "" &&
                            type === "fieldForceAccount") ||
                          (type === "confirm_create_account" &&
                            ifscCode &&
                            bankAccNumber)
                        ? true
                        : false,
                },
                // {
                //   name: "24 hours transaction limit",
                //   short_name: "24 hrs limit",
                //   isMulti: false,
                //   value: limit24hr,
                //   setValue: (val) => {
                //     setLimit24hr(val);
                //     handleSubmit("limit", val);
                //   },
                //   isDropdown: false,
                //   isDisabled:
                //     fieldForceAccountNo !== "" && type === "fieldForceAccount"
                //       ? true
                //       : false,
                //   valueType: "number",
                // },
                {
                  name: "PAN",
                  short_name: "PAN",
                  isMulti: false,
                  value:
                    type === "confirm_create_account" && panNum
                      ? panNum
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing")
                        ? activeInactivePan
                        : popupType === "associated"
                          ? fieldForcePan
                          : fieldForcePan !== "" &&
                              type === "fieldForceAccount" &&
                              flow !== "create"
                            ? fieldForcePan
                            : panNumber.toUpperCase(),
                  setValue: (val) => {
                    resetToFirstPage();
                    setPanNumber(val);
                    handleSubmit("pan", val);
                  },
                  valueType: "string",
                  isDropdown: false,
                  isDisabled:
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Pan" ||
                      activeInactiveFlow === "Existing")
                      ? true
                      : (fieldForcePan !== "" &&
                            type === "fieldForceAccount") ||
                          (type === "confirm_create_account" && panNum)
                        ? true
                        : false,
                },
                {
                  name: "Category",
                  valueType: "string",
                  short_name: "Cat",
                  isMulti: false,
                  value: currentCategory,
                  setValue: (val) => {
                    resetToFirstPage();
                    setCurrentCategory(val);
                    const categoryName =
                      inputData.find(
                        (category) => String(category?.id) === String(val),
                      )?.Category ?? "";
                    setDisplayCategory(categoryName);
                    handleSubmit("category", val);
                    handleSubmit("dispCat", categoryName);
                  },
                  isDropdown: true,
                  isDisabled: loading ? true : false,
                  displayValue: displayCategory,
                },
                {
                  name: "Labels",
                  short_name: "Lab",
                  isMulti: true,
                  value: LabelSearchText,
                  setValue: (val) => {
                    resetToFirstPage();
                    setLabelSearchText(val);
                    handleSubmit(
                      "label",
                      Array.isArray(val) ? val.join(",") : val,
                    );
                  },
                  isDropdown: true,
                  valueType: "string",
                  isDisabled: loading,
                },
              ],
              filters: [
                {
                  name: "Account status",
                  filterType: "dropdown",
                  variant: "single",
                  size: "small",
                  dropdownPlaceHolder: "Select status",
                  isDisabled: type === "activeInactive" ? true : false,
                  value:
                    currentStatus === "pending" &&
                    services?.includes("FFAAccount")
                      ? "require approval"
                      : currentStatus,
                  options: [
                    "approved",
                    services?.includes("FFAAccount")
                      ? "require approval"
                      : "pending",
                    "rejected",
                    "blocked",
                    "archived",
                  ],
                  statusPop: true,
                  handleChange: (e) => {
                    if (
                      (type === "activeInactive" &&
                        accActiveInactiveState === "active") ||
                      (type === "activeInactive" &&
                        accActiveInactiveState === "inactive")
                    ) {
                      return;
                    }
                    setCurrentStatus(e);
                    setAnimateViewAll(false);
                    resetToFirstPage();
                    handleSubmit("status", e);
                  },
                },
                {
                  name: "Date range",
                  filterType: "calender",
                  variant: "range",
                  size: "small",
                  value: startDateFilter && endDateFilter,
                  isDisable: false,
                  startDate: startDateFilter
                    ? new Date(
                        startDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : startDateFilter,
                  endDate: endDateFilter
                    ? new Date(
                        endDateFilter * IntervalConfiguration.intervalMedium,
                      )
                    : endDateFilter,
                  handleChange: (date) => {
                    handleDateChange(date);
                    setAnimateViewAll(false);
                  },
                },
              ],
              isFilterClearAllDisabled: !(
                (startDateFilter && endDateFilter) ||
                currentStatus !== ""
              ),
              isSearchClearAllDisabled:
                (type === "confirm_create_account" ||
                  type === "activeInactive") &&
                ((isIfsc?.length &&
                  accountNumber.length &&
                  !panNumber.length &&
                  !currentCategory?.length &&
                  !LabelSearchText?.length &&
                  !searchUserText?.length) ||
                  (!isIfsc?.length &&
                    !accountNumber?.length &&
                    panNumber?.length &&
                    !currentCategory?.length &&
                    !LabelSearchText?.length &&
                    !searchUserText?.length))
                  ? true
                  : !(
                      accountNumber?.length ||
                      isIfsc?.length ||
                      panNumber?.length ||
                      currentCategory?.length ||
                      LabelSearchText?.length ||
                      searchUserText?.length ||
                      loading
                    ),
              inputData: inputData,
              active: active,
              setActive: setActive,
              loadingData: loadingData,
              loading: loading,
              isSortDisabled: loading,
              isFilterDisabled: loading,
              setLoading: setLoadingData,
              isShowFilter: true,
            }}
            ispagination={
              accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                ? false
                : true
            }
          />
        </div>

        {!toggleFfa ? (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            className={` ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            } ${showInnerSearchBar ? "" : ""} ${
              type === "fieldForceAccount" || type === "activeInactive"
                ? " h-full flex flex-col flex-1 overflow-hidden min-h-0"
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-0"
            } ${loading || showInnerSearchBar ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden"}`}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.preventDefault();

                return false;
              }
            }}
          >
            {showInnerSearchBar && (
              <div className="w-screen h-full-height absolute bg-PopUp-BackDrop opacity-dark-opacity z-z-index-content"></div>
            )}
            {loading ? (
              <div className="loader-container grid place-items-center h-full w-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <div
                className={`${animateViewAll ? "animate-slide-prev" : ""} scroll flex flex-col  min-h-0 items-center h-full-height overflow-y-auto ${showInnerSearchBar && "pointer-events-none opacity-dark-opacity"} w-full flex-1`}
                ref={scrollContainerRef}
                onScroll={handleScroll}
              >
                <div
                  className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md `}
                >
                  {accumulatedData?.map((account, index) => {
                    return (
                      <CardContainer
                        hoverHeight={
                          GlobalConfiguration?.fieldForceAccountountCardHoverHeight
                        }
                        filterRef={scrollContainerRef}
                        context={account}
                        isSelected={
                          Array.isArray(LabelAccounts) &&
                          LabelAccounts?.some((item) => item?.id === account.id)
                        }
                        isDisabled={
                          id === account?.id
                            ? true
                            : flow === "create" &&
                              ["blocked", "archived", "rejected"].includes(
                                account?.approval_status,
                              )
                        }
                        onClickHandler={(e, data) => {
                          if (
                            isEmbeddedPopup &&
                            !isLabelClicked &&
                            flow !== "create"
                          ) {
                            handleEmbeddedPopupAccountNavigate(account.id);
                            return;
                          }
                          if (
                            type === "activeInactive" ||
                            type === "confirm_create_account"
                          ) {
                            setIsalertPopup(true);
                            setFlowSelectedId(account?.id);
                            return;
                          }
                          // if (type === "fieldForceAccount") {
                          //   actionRestricted();
                          //   return;
                          // }
                          if (popupType === "associated")
                            setOpenBeneAssociate(false);
                          if (flow === "create") {
                            handleDataPopup(data);
                            setModalOpen(false);
                          } else {
                            if (!isLabelClicked) {
                              navigate(
                                `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${account.id}`,
                                {
                                  state: {
                                    isViewAll:
                                      location.pathname.includes("view_all"),
                                  },
                                },
                              );
                              if (type === "fieldForceAccount") {
                                setOpenBeneAssociate(false);
                              }
                            } else {
                              handleLabelAccountSelect(data);
                            }
                          }
                        }}
                      >
                        <card-body>
                          <TextWithIcon
                            type={"text"}
                            text={account?.name}
                            textColor={"var(--text-primary)"}
                            subText={"Account name"}
                            iconComponentArray={[
                              ...(isLabelClicked
                                ? [
                                    {
                                      icon:
                                        Array.isArray(LabelAccounts) &&
                                        LabelAccounts?.some(
                                          (item) => item?.id === account.id,
                                        )
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                                      isDisabled: false,
                                    },
                                  ]
                                : []),
                            ]}
                          />

                          <div className="flex gap-x-gap-sm justify-between items-center">
                            <div className="flex gap-x-gap-sm justify-between items-center">
                              <div className="flex flex-1 truncate flex-col gap-y-gap-xs">
                                <p
                                  className={`text-font-sm text-text-primary flex-1 truncate font-normal pl-mobile-padding-l Qmd:pl-padding-sm`}
                                >
                                  <TickerAnimation
                                    text={formatAccountNumber(
                                      account.bank_acc_no,
                                    ).toUpperCase()}
                                  />
                                </p>
                                <div className="w-full relative flex pl-mobile-padding-l Qmd:pl-padding-sm justify-between items-center">
                                  <p className="text-font-xs text-text-secondary flex-1 truncate font-normal transform-none">
                                    Account number
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="bg-text-primary flex items-center pl-mobile-padding-l Qmd:pl-padding-sm gap-x-gap-sm rounded-l-border-radius-md py-padding-xs px-padding-sm">
                              <div className="Qsmd:w-banklogo-width-sm Qsmd:h-banklogo-height-sm w-banklogo-width-mobile h-banklogo-height-mobile flex-shrink-0">
                                <IfscCodeMapper ifscCode={account?.ifsc_code} />
                              </div>
                            </div>
                          </div>
                        </card-body>
                        <card-hover>
                          <TextWithIcon
                            text={
                              account?.approval_status === "pending" &&
                              services?.includes("FFAAccount")
                                ? "require approval"
                                : account?.approval_status
                            }
                            subText={"Account status"}
                            textCase={"capitalize"}
                            fontWeight={"semibold"}
                            textColor={getStatusColor(account?.approval_status)}
                          />

                          <TextWithIcon
                            text={
                              filterUppercaseLabels(account?.labels).join(
                                ", ",
                              ) || "Not assigned"
                            }
                            iconComponentArray={[
                              {
                                icon: ICONS?.LABEL,
                              },
                            ]}
                            fontWeight={"normal"}
                            textColor={"var(--text-primary)"}
                          />
                        </card-hover>
                      </CardContainer>
                    );
                  })}
                </div>
              </div>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full ">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p
                  className={`text-font-sm text-text-primary  items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  {type === "activeInactive" &&
                  accActiveInactiveState === "active"
                    ? "No active field force associated accounts found."
                    : type === "activeInactive" &&
                        accActiveInactiveState === "inactive"
                      ? "No inactive field force associated accounts found."
                      : "No data found."}
                </p>

                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active field force accounts linked to the provided bank under the field force account classification."
                        : "There are no existing inactive field force accounts linked to the provided bank under the field force account classification."}
                    </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active field force accounts linked to the provided PAN under the field force account classification."
                        : "There are no existing inactive field force accounts linked to the provided PAN under the field force account classification."}
                    </p>
                  )
                ) : (
                  (type === "confirm_create_account"
                    ? currentCategory !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied ||
                      (activeType === "Pan"
                        ? accountNumber !== "" || isIfsc !== ""
                        : panNumber !== "")
                    : currentCategory !== "" ||
                      panNumber !== "" ||
                      accountNumber !== "" ||
                      isIfsc !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        ) : (
          <div
            ref={scrollContainerRef}
            tabIndex="0"
            className={`h-height-full ${
              accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
              loading
                ? "pb-bottom-base"
                : isLabelClicked
                  ? "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
                  : "pb-[var(--pagination-height)]"
            } ${showInnerSearchBar ? "" : ""} ${
              type === "fieldForceAccount" || type === "activeInactive"
                ? " h-full flex flex-col flex-1 overflow-hidden min-h-height-base"
                : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-height-base"
            } ${loading || showInnerSearchBar ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden"} `}
            onKeyDown={(event) => {
              if (
                event.key === "w" ||
                event.key === "s" ||
                event.key === "W" ||
                event.key === "S" ||
                event.code === "KeyS" ||
                event.code === "KeyW" ||
                event.keyCode === "83" ||
                event.keyCode === "87" ||
                event.key === "ArrowUp" ||
                event.key === "ArrowDown"
              ) {
                event.stopPropagation();
                event.preventDefault();

                return false;
              }
              event.stopPropagation();
            }}
          >
            {showInnerSearchBar && (
              <div className="w-screen h-full-height absolute bg-PopUp-BackDrop opacity-dark-opacity z-z-index-content"></div>
            )}
            {loading ? (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            ) : !!filteredData?.length ? (
              <>
                <div
                  className={`${toggleFfa && animateViewAll && currentPage === GlobalConfiguration?.lengthCheckOne ? "animate-slide-next" : ""} scroll flex flex-col items-center relative  min-h-0 h-full-height overflow-y-auto  w-full flex-1 z-z-index-base`}
                  ref={scrollContainerRef}
                  onScroll={handleScroll}
                  style={{
                    scrollPaddingTop: "var(--padding-md)",
                    scrollPaddingBottom: "var(--padding-md)",
                  }}
                >
                  <div className="standard-list-view-alignment">
                    {accumulatedData?.map((item) => {
                      return (
                        <ListContainer
                          hoverHeight={
                            GlobalConfiguration?.fieldForceAccountountListHoverHeight
                          }
                          key={item.id}
                          filterRef={scrollContainerRef}
                          onClickHandler={(e) => {
                            if (
                              isEmbeddedPopup &&
                              !isLabelClicked &&
                              flow !== "create"
                            ) {
                              handleEmbeddedPopupAccountNavigate(item.id);
                              return;
                            }
                            if (
                              type === "activeInactive" ||
                              type === "confirm_create_account"
                            ) {
                              setIsalertPopup(true);
                              setFlowSelectedId(item?.id);
                              return;
                            }
                            // if (type === "fieldForceAccount") {
                            //   actionRestricted();
                            //   return;
                            // }
                            if (popupType === "associated")
                              setOpenBeneAssociate(false);
                            if (flow === "create") {
                              handleDataPopup(item);
                              setModalOpen(false);
                            } else {
                              if (!isLabelClicked) {
                                navigate(
                                  `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${item.id}`,
                                  {
                                    state: {
                                      isViewAll:
                                        location.pathname.includes("view_all"),
                                    },
                                  },
                                );
                                if (type === "fieldForceAccount") {
                                  setOpenBeneAssociate(false);
                                }
                              } else {
                                handleLabelAccountSelect(item);
                              }
                            }
                          }}
                          isSelected={
                            Array.isArray(LabelAccounts) &&
                            LabelAccounts?.some((acc) => acc?.id === item.id)
                          }
                          isDisabled={
                            id === item?.id
                              ? true
                              : flow === "create" &&
                                ["blocked", "archived", "rejected"].includes(
                                  item?.approval_status,
                                )
                          }
                          context={item}
                        >
                          <list-body>
                            <div className="w-full flex justify-between pr-padding-sm gap-x-gap-sm py-padding-sm">
                              <div
                                className={`flex flex-col gap-y-gap-sm w-full`}
                              >
                                <div className="w-full flex gap-x-gap-sm">
                                  <div className="bg-text-primary py-padding-xs flex justify-center items-center px-padding-sm rounded-r-border-radius-md">
                                    <CommonBankLogo
                                      variant="small"
                                      ifsc={item.ifsc_code}
                                    />
                                  </div>
                                  <div className="text-text-primary text-font-xs flex-1 min-w-standard-account-min-width truncate flex font-normal">
                                    <TickerAnimation
                                      text={standardAccountNumberFormat(
                                        item?.bank_acc_no,
                                      )}
                                    />
                                  </div>
                                  <div className="border-l border-primary-bg"></div>
                                  <div className="flex gap-x-gap-sm justify-end items-center">
                                    <p
                                      style={{
                                        color: getStatusColor(
                                          item?.approval_status,
                                        ),
                                      }}
                                      className={` text-font-xs font-semibol capitalize min-w-standard-approval-status-min-width text-right`}
                                    >
                                      {/* {item?.approval_status} */}
                                      {item?.approval_status === "pending" &&
                                      services?.includes("FFAAccount")
                                        ? "require approval"
                                        : item?.approval_status}
                                    </p>

                                    <img
                                      style={{
                                        display: isLabelClicked
                                          ? "flex"
                                          : "none",
                                      }}
                                      className="w-icon-sm h-icon-sm flex-shrink-0 cursor-pointer"
                                      src={
                                        Array.isArray(LabelAccounts) &&
                                        LabelAccounts?.some(
                                          (acc) => acc?.id === item.id,
                                        )
                                          ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                                      }
                                      alt=""
                                    />
                                  </div>
                                </div>
                                <div className="w-full pl-padding-sm  flex justify-between items-center relative">
                                  <p
                                    className={`text-font-xs text-text-primary flex-1 truncate font-normal`}
                                  >
                                    <TickerAnimation text={item?.name} />
                                  </p>
                                </div>
                              </div>
                            </div>
                          </list-body>
                          <list-hover>
                            <ListTextWithIcon
                              type={"text"}
                              text={
                                filterUppercaseLabels(item?.labels).join(
                                  ", ",
                                ) || "Not assigned "
                              }
                              iconComponentArray={[
                                {
                                  icon: ICONS?.LABEL,
                                },
                              ]}
                            />
                          </list-hover>
                        </ListContainer>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : !accumulatedData?.length &&
              !filteredData?.length &&
              !loading ? (
              <div className="flex flex-col items-center justify-center m-auto w-full h-full">
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className={` opacity-base-opacity w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm`}
                />
                <p
                  className={`text-font-sm text-text-primary  items-center font-semibold ${
                    type === "activeInactive" &&
                    (activeInactiveFlow === "Bank" ||
                      activeInactiveFlow === "Existing") &&
                    (currentCategory !== "" ||
                      panNumber !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied)
                      ? "mb-margin-sm"
                      : type === "activeInactive" &&
                          (activeInactiveFlow === "Pan" ||
                            activeInactiveFlow === "Existing") &&
                          (currentCategory !== "" ||
                            accountNumber !== "" ||
                            isIfsc !== "" ||
                            searchUserText !== "" ||
                            isFilterApplied)
                        ? "mb-margin-sm"
                        : type === "activeInactive"
                          ? "mb-margin-xs"
                          : "mb-margin-sm"
                  }`}
                >
                  {type === "activeInactive" &&
                  accActiveInactiveState === "active"
                    ? "No active field force associated accounts found."
                    : type === "activeInactive" &&
                        accActiveInactiveState === "inactive"
                      ? "No inactive field force associated accounts found."
                      : "No data found."}
                </p>
                {type === "activeInactive" && activeInactiveFlow === "Bank" ? (
                  currentCategory !== "" ||
                  panNumber !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active field force accounts linked to the provided bank under the field force account classification."
                        : "There are no existing inactive field force accounts linked to the provided bank under the field force account classification."}
                    </p>
                  )
                ) : type === "activeInactive" &&
                  activeInactiveFlow === "Pan" ? (
                  currentCategory !== "" ||
                  accountNumber !== "" ||
                  isIfsc !== "" ||
                  searchUserText !== "" ||
                  isFilterApplied ? (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  ) : (
                    <p className="text-text-secondary text-font-sm w-no-associate-found-width text-center">
                      {accActiveInactiveState === "active"
                        ? "There are no existing active field force accounts linked to the provided PAN under the field force account classification."
                        : "There are no existing inactive field force accounts linked to the provided PAN under the field force account classification."}
                    </p>
                  )
                ) : (
                  (type === "confirm_create_account"
                    ? currentCategory !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied ||
                      (activeType === "Pan"
                        ? accountNumber !== "" || isIfsc !== ""
                        : panNumber !== "")
                    : currentCategory !== "" ||
                      panNumber !== "" ||
                      accountNumber !== "" ||
                      isIfsc !== "" ||
                      searchUserText !== "" ||
                      isFilterApplied) && (
                    <PrimaryButton
                      enabledBgColor="var(--primary-nav-act)"
                      btnText="Clear parameters"
                      btnType="button"
                      handleFunction={() => {
                        handleClearFilters();
                      }}
                      enabledTextColor="var(--text-primary)"
                    />
                  )
                )}
              </div>
            ) : (
              <div className="loader-container grid place-items-center w-full h-full">
                <Loader />
              </div>
            )}

            {(currentStatus === "" || currentStatus === "all") && (
              <div ref={lastElementRef}></div>
            )}
          </div>
        )}

        {isLabelClicked && (
          <div className="flex-shrink-0 Qmd:hidden block"></div>
        )}
      </div>
    </>
  );
};

export default FieldForceAccountViewAll;
